module.exports = __webpack_public_path__ + "img/energy.01a2ea56.png";